import {  useNavigate, useSearchParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import logo from './assets/header.png';
import { useEffect, useState } from 'react';
import { check_set_pwd, set_pwd } from './utils/services';
import md5 from 'md5';

function SetPWD() {
  

  const navigate = useNavigate();

  const location = useLocation();
  const { parametro } = location.state || {};
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");
  const token = searchParams.get("token");

 // Estados para almacenar el nombre de usuario, la contraseña y la confirmación
 const [name, setName] = useState('');
 const [password, setPassword] = useState('');
 const [confirmPassword, setConfirmPassword] = useState('');

 // Estados para manejar los mensajes de error
 const [nameError, setNameError] = useState('');
 const [passwordError, setPasswordError] = useState('');
 const [confirmPasswordError, setConfirmPasswordError] = useState('');
 const [successMessage, setSuccessMessage] = useState('');

 const [status, setstatus] = useState(0);

 // Función para manejar el envío del formulario
 const handleSubmit = (e) => {
   e.preventDefault(); // Previene el comportamiento por defecto del formulario

   // Reiniciar los mensajes de error y éxito
   setNameError('');
   setPasswordError('');
   setConfirmPasswordError('');
   setSuccessMessage('');

   let isValid = true;

   // --- Validaciones ---
   // Validar nombre
   if (name.trim() === '') {
     setNameError('Setting a name is mandatory');
     isValid = false;
   }

   // Validar contraseña
   if (password.length < 6) {
     setPasswordError('Password should be 6 or more characters');
     isValid = false;
   }

   // Validar confirmación de contraseña
   if (password !== confirmPassword) {
     setConfirmPasswordError("Password doesn't match");
     isValid = false;
   }

   // Si todas las validaciones pasan
   if (isValid) {
     // Aquí podrías enviar los datos al backend
  
        async function set_password() {

          const usrList = await set_pwd(token,email,md5(confirmPassword), name);
          if (usrList==null){
            navigate("/");
          }else {
              setSuccessMessage('¡Password Setted!');
              setName('');
              setPassword('');
              setConfirmPassword('');
              setstatus(1);
          }
        }

        set_password();

   }
 };

 async function fetch_check_token() {

  const usrList = await check_set_pwd(token,email);

  if (usrList==null){
    navigate("/");
  }else {
    setName(usrList[0].usr_name);
    //navigate("/opportunitypage?id=" + opportunityList);
  }
}

 useEffect(() => {
  fetch_check_token();
}, []); 

 return (
   <div className="App d-flex justify-content-center align-items-center min-vh-100 bg-light">
     <header className="App-header bg-white p-5 rounded shadow-sm text-center" style={{ maxWidth: '400px', width: '100%' }}>
       <img src={logo} className="App-logo mb-4" alt="logo" style={{ height: '80px' }} />
       <p className="lead mb-1">TOMi Management System</p>
       <h2 className="mb-4">Set password</h2>

    
       <form onSubmit={handleSubmit}>
      {!successMessage && (
        <>
         {/* Campo para el nombre */}
         <div className="mb-3 text-start">
           <label htmlFor="name" className="form-label">Your Name</label>
           <input
             type="text"
             className={`form-control ${nameError ? 'is-invalid' : ''}`}
             id="name"
             placeholder="Type your name"
             value={name}
             onChange={(e) => setName(e.target.value)}
           />
           {nameError && <div className="invalid-feedback">{nameError}</div>}
         </div>

         {/* Campo para la contraseña */}
         <div className="mb-3 text-start">
           <label htmlFor="password" className="form-label">Password</label>
           <input
             type="password"
             className={`form-control ${passwordError ? 'is-invalid' : ''}`}
             id="password"
             placeholder="Type a password"
             value={password}
             onChange={(e) => setPassword(e.target.value)}
           />
           {passwordError && <div className="invalid-feedback">{passwordError}</div>}
         </div>

         {/* Campo para confirmar la contraseña */}
         <div className="mb-4 text-start">
           <label htmlFor="confirmPassword" className="form-label">Re-enter your passowrd</label>
           <input
             type="password"
             className={`form-control ${confirmPasswordError ? 'is-invalid' : ''}`}
             id="confirmPassword"
             placeholder="Confirm your password"
             value={confirmPassword}
             onChange={(e) => setConfirmPassword(e.target.value)}
           />
           {confirmPasswordError && <div className="invalid-feedback">{confirmPasswordError}</div>}
         </div>
         </>
         )}

         {/* Mensaje de éxito */}
         {successMessage && (
           <div className="alert alert-success mt-3" role="alert">
             {successMessage}
           </div>
         )}

        {successMessage ? (
          <button onClick={()=>navigate("/")} className="btn btn-primary w-100">Go to login</button>
         ):
         <button type="submit" className="btn btn-primary w-100">Set Password</button>
        }
         {/* Botón de envío */}
        
       </form>
     </header>
   </div>
 );
}


export default SetPWD;
